import { RoleGuard } from '../guards';
import TrainerProfile from '../../pages/trainer/profile';
import TrainerHelpCenter from '../../pages/trainer/helpcenter';
import TrainerAddressBook from '../../pages/trainer/addressbook';
import TrainerWorkingInProgress from '../../pages/trainer/wip';
import ManagementLMScertificates from '../../pages/trainer/lms/certificates/containers/certificates';
import ManagementLMSCertifiedUsers from '../../pages/trainer/lms/certified-users/containers/certified-users';
import ManagementLMSChapters from '../../pages/trainer/lms/chapters/containers/chapters';
import ManagementLMSChapter from '../../pages/trainer/lms/chapters/containers/chapter';
import ManagementLMSCollections from '../../pages/trainer/lms/collections/containers/collections';
import ManagementLMSCourses from '../../pages/trainer/lms/courses/containers/courses';
import ManagementLMSCollection from '../../pages/trainer/lms/collections/containers/collection';
import ManagementLMSCourse from '../../pages/trainer/lms/courses/containers/course';
import ManagementLMSLearningPaths from '../../pages/trainer/lms/learning-paths/containers/learning-paths';
import ManagementLMSLearningPath from '../../pages/trainer/lms/learning-paths/containers/learning-path';
import ManagementLMSModules from '../../pages/trainer/lms/modules/containers/modules';
import ManagementLMSModule from '../../pages/trainer/lms/modules/containers/module';
import ManagementLMSTopics from '../../pages/trainer/lms/topics/containers/topics';
import ManagementLMSTopic from '../../pages/trainer/lms/topics/containers/topic';


export const TrainerRoutes = () => {

	return ([

		// Start - Profile
		{ path: 'profile', element: <RoleGuard roles={["Trainer"]}><TrainerProfile /></RoleGuard> },
		{ path: 'helpcenter', element: <RoleGuard roles={["Trainer"]}><TrainerHelpCenter /></RoleGuard> },
		{ path: 'address', element: <RoleGuard roles={["Trainer"]}><TrainerAddressBook /></RoleGuard> },
		{ path: 'wip', element: <RoleGuard roles={["Trainer"]}><TrainerWorkingInProgress /></RoleGuard> },


		// End - Profile
		{ path: "lms/certificates", element: <RoleGuard roles={["Internal"]}><ManagementLMScertificates /></RoleGuard> },
		{ path: "lms/certified-users", element: <RoleGuard roles={["Internal"]}><ManagementLMSCertifiedUsers /></RoleGuard> },
		{ path: "lms/chapters", element: <RoleGuard roles={["Internal"]}><ManagementLMSChapters /></RoleGuard> },
		{ path: "lms/chapters/:id", element: <RoleGuard roles={["Internal"]}><ManagementLMSChapter /></RoleGuard> },
		{ path: "lms/collections", element: <RoleGuard roles={["Internal"]}><ManagementLMSCollections /></RoleGuard> },
		{ path: "lms/collections/:id", element: <RoleGuard roles={["Internal"]}><ManagementLMSCollection /></RoleGuard> },
		{ path: "lms/courses", element: <RoleGuard roles={["Internal"]}><ManagementLMSCourses /></RoleGuard> },
		{ path: "lms/courses/:id", element: <RoleGuard roles={["Internal"]}><ManagementLMSCourse /></RoleGuard> },
		{ path: "lms/learning-paths", element: <RoleGuard roles={["Internal"]}><ManagementLMSLearningPaths /></RoleGuard> },
		{ path: "lms/learning-paths/:id", element: <RoleGuard roles={["Internal"]}><ManagementLMSLearningPath /></RoleGuard> },
		{ path: "lms/modules", element: <RoleGuard roles={["Internal"]}><ManagementLMSModules /></RoleGuard> },
		{ path: "lms/modules/:id", element: <RoleGuard roles={["Internal"]}><ManagementLMSModule /></RoleGuard> },
		{ path: "lms/topics", element: <RoleGuard roles={["Internal"]}><ManagementLMSTopics /></RoleGuard> },
		{ path: "lms/topics/:id", element: <RoleGuard roles={["Internal"]}><ManagementLMSTopic /></RoleGuard> },
		// Start - Work In Progress
		{ path: 'venture', element: <RoleGuard roles={["Trainer"]}><TrainerWorkingInProgress /></RoleGuard> },
		{ path: 'community', element: <RoleGuard roles={["Trainer"]}><TrainerWorkingInProgress /></RoleGuard> },
		{ path: 'OneXProjects', element: <RoleGuard roles={["Trainer"]}><TrainerWorkingInProgress /></RoleGuard> },

	])
};
